import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Link from 'gatsby-link';
var TYPE_MAP = {
  'class': 'CLASSES',
  'namespace': 'NAMESAPCES',
  'module': 'MODULES',
  'external': 'EXTERNALS',
  'mixin': 'MIXINS',
  'global': 'GLOBALS',
  'example': 'Examples'
};
var REPLACED_PATTERN = /[-[\]/{}()*+?.\\^$|]/g;
var REPLACED_VALUE = '\\$&';

var SearchList =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SearchList, _React$Component);

  function SearchList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SearchList.prototype;

  _proto.hightliging = function hightliging(fullText) {
    var escapeValue = this.props.value.replace(REPLACED_PATTERN, REPLACED_VALUE);
    var pattern = new RegExp(escapeValue, 'ig');
    var joined = fullText.replace(pattern, function (text) {
      return "<strong>" + text + "</strong>";
    });
    return React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: joined
      }
    });
  };

  _proto.getListItemComponent = function getListItemComponent(item, index) {
    var movedIndex = this.props.movedIndex;
    var _item$node = item.node,
        pid = _item$node.pid,
        name = _item$node.name,
        parentPid = _item$node.parentPid;
    return React.createElement("li", {
      className: "item" + (movedIndex === index ? ' selected' : ''),
      key: "search-item-" + index
    }, React.createElement(Link, {
      to: "/" + pid,
      className: "ellipsis"
    }, this.hightliging(name), React.createElement("span", {
      className: "nav-group-title"
    }, TYPE_MAP[parentPid] || parentPid)));
  };

  _proto.getResultComponent = function getResultComponent() {
    var _this = this;

    var result = this.props.result;
    var component;

    if (result.length) {
      component = React.createElement("ul", null, result.map(function (item, index) {
        return _this.getListItemComponent(item, index);
      }));
    } else {
      component = React.createElement("p", {
        className: "no-result"
      }, "No Result");
    }

    return component;
  };

  _proto.render = function render() {
    if (this.props.searching) {
      return React.createElement("div", {
        className: "search-list"
      }, this.getResultComponent());
    }

    return null;
  };

  return SearchList;
}(React.Component);

export default SearchList;